const colors = {
    darkGrey: '#333',
    lightGrey: '#bababd',
};

export const theme = {
    light: {
        text: colors.darkGrey,
    },
    dark: {
        text: colors.lightGrey,
    },
};
